/**
 * Display units for the Glow designer. Geometry is stored in metres and
 * degrees; US accounts see square feet. Pitch uses degrees in every region.
 */

/** Square feet in one square metre (international foot). */
export const SQFT_PER_M2 = 10.76391041671;

/**
 * Sloping roof surface from a face's plan (horizontal) area: plan ÷ cos pitch.
 * Face polygons are stored on the ground plane, so this is the area the
 * installer actually works on. Pitch is the physical roof's, never a frame's.
 */
export const roofSurfaceAreaMeters2 = (
  planAreaMeters2: number,
  roofPitchDegrees: number
): number => {
  const pitch = Math.min(Math.max(roofPitchDegrees, 0), 85);
  return planAreaMeters2 / Math.cos((pitch * Math.PI) / 180);
};

export const formatRoofArea = (
  areaMeters2: number,
  region: 'uk' | 'us'
): string => {
  if (region === 'us') {
    return `${Math.round(areaMeters2 * SQFT_PER_M2)} ft²`;
  }
  return `${Math.round(areaMeters2)} m²`;
};

export const formatRoofPitch = (pitchDegrees: number): string =>
  `${Math.round(pitchDegrees * 10) / 10}°`;
